export class Incidencia {
    id: number = 0;
    titol: string = '';
    lloc: string = '';
    comentari: string = '';
    incidenciaMinimizada: boolean = true;
}
